var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0645 3.93418C27.1552 2.02482 24.0595 2.02488 22.1502 3.93431L4.85655 21.2293C4.35234 21.7335 4.0046 22.3728 3.85518 23.07L2.52222 29.2905C2.45114 29.6222 2.55305 29.9673 2.79291 30.2072C3.03277 30.447 3.37787 30.5489 3.70955 30.4779L9.9299 29.1449C10.6273 28.9955 11.2666 28.6477 11.7709 28.1433L26.7494 13.1637L27.0251 13.4394C27.6109 14.0252 27.6109 14.9749 27.0251 15.5607L24.7929 17.793C24.4024 18.1835 24.4024 18.8166 24.7929 19.2072C25.1834 19.5977 25.8166 19.5977 26.2071 19.2072L28.4393 16.9749C29.8062 15.6081 29.8062 13.392 28.4393 12.0252L28.1636 11.7494L29.0647 10.8483C30.9738 8.93893 30.9738 5.84343 29.0645 3.93418ZM23.5644 5.34847C24.6927 4.22014 26.522 4.2201 27.6503 5.34839C28.7785 6.47662 28.7786 8.30583 27.6504 9.4341L10.3567 26.7292C10.125 26.9609 9.83124 27.1207 9.51084 27.1893L4.80164 28.1985L5.81079 23.4891C5.87943 23.1688 6.03918 22.8751 6.27082 22.6434L23.5644 5.34847Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.4df8c4324dfdd375f625c90d772e4e72.svg";
export { ForwardRef as ReactComponent };